import { entity, list } from "./base";
import { concatModules } from "@/utility";


const name = "reminder_histories";

const reminderModule = {
  state: {
    open: false,
    pk: null,
    targets: []
  },
  mutations: {
    open(state, { pk }) {
      state.open = true;
      state.pk = pk;
    },
    close(state) {
      state.open = false;
      state.pk = null;
    },
    fetchedTargets(state, {payload}) {
      state.targets = payload
    }
  },
  actions: {
    targets({ commit }, { }) {
      const store = this;
      return new Promise((resolve, reject) => {
        store.$axios
          .get(`/${name}/targets/${this.pk}`)
          .then((response) => {
            commit("fetchedTargets", {
              payload: response.data.data
            });

            resolve();
          })
          .catch((error) => {
            commit("failed", { error });

            reject(error);
          });
      });
    },
    histories({ commit, getters },
              { id, page, filters = [], sort = {}}) {
      const store = this;
      let params = {
        page,
        perPage: getters.perPage,
        filters: JSON.stringify(filters),
        sorts:
          Object.keys(sort).length > 0
            ? JSON.stringify([sort])
            : undefined
      };

      return new Promise((resolve, reject) => {
        store.$axios
          .get(`/${name}/${id}`, {
            params: params
          })
          .then((response) => {
            commit("succeeded", {
              entities: response.data.data,
              total: response.data.total,
              page: page
            });

            resolve();
          })
          .catch((error) => {
            commit("failed", { error });

            reject(error);
          });
      });
    }
  },
  getters: {
    open(state) {
      return state.open;
    },
    pk(state) {
      return state.pk;
    },
    targets(state) {
      return state.targets || [];
    }
  }
};

const listModule = list(name);

export const reminder_histories = {
  namespaced: true,
  modules: {
    list: concatModules(listModule, reminderModule)
  }
};
